import {equals, flow, get} from '@logistics-frontend/utils'

import {ActionOpenYandexMessengerSupportChat} from 'src/api'

import {SupportAction} from './types'

// @ts-expect-error ts(2322) жалуется, что возвращаемый тип должен быть boolean
const isOpenYandexMessengerSupportChatAction: (
  action: SupportAction,
) => action is ActionOpenYandexMessengerSupportChat = flow(get('type'), equals('open_yandex_messenger_support_chat'))

export const mapToSupportContext = (action: SupportAction) => {
  if (isOpenYandexMessengerSupportChatAction(action)) {
    const {order_id, entrypoint, user_phone_id, user_id} = get('messenger_data.payload', action) || {}

    return {
      entrypoint,
      order_id,
      user_id,
      user_phone_id,
    }
  }

  const {lp_order_id} = action.ndd_data || {}

  return {
    entrypoint: 'logistic_ndd_users',
    order_id: lp_order_id,
  }
}
